import React from 'react';
import { CSSProperties } from 'react';
import { styled } from '@mui/material';
import { Alignment } from '../../dto/Types/UIType';

interface Props {
  centered?: boolean;
  grow?: boolean;
  children?: React.JSX.Element | React.JSX.Element[];
  className?: string;
  onClick?: React.EventHandler<React.MouseEvent<HTMLDivElement>>;
  hAlign?: Alignment;
  vAlign?: Alignment;
  style?: CSSProperties;
  testId?: string;
}

const getGrowStyles = (grow: boolean | undefined) => {
  return grow
    ? {
        flexGrow: 1,
      }
    : {};
};

const getCenteredStyles = (centered: boolean | undefined) => {
  return centered
    ? {
        alignItems: 'center',
        justifyContent: 'center',
      }
    : {};
};

const StyledRow = styled('div')<{
  grow: boolean | undefined;
  centered?: boolean;
  vAlign?: Alignment;
  hAlign?: Alignment;
}>(({ grow, centered, vAlign, hAlign }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: hAlign,
  alignItems: vAlign,
  ...getGrowStyles(grow),
  ...getCenteredStyles(centered),
}));

const Row: React.FC<Props> = ({ hAlign, vAlign, grow, centered, children, className, onClick = () => {}, style, testId }) => {
  return (
    <StyledRow
      className={className}
      onClick={(e: any) => {
        onClick(e);
      }}
      style={style}
      data-testid={testId}
      grow={grow}
      centered={centered}
      hAlign={hAlign}
      vAlign={vAlign}
    >
      {children}
    </StyledRow>
  );
};

export default Row;
